/* Product Page CRO — free gift oil picker.
   The BXGY automatic discount does the pricing; this just adds the line. */
(function () {
  function init(root) {
    if (root.dataset.croBound) return;
    root.dataset.croBound = '1';

    var select = root.querySelector('[data-cro-gift-select]');
    var btn    = root.querySelector('[data-cro-gift-add]');
    var status = root.querySelector('[data-cro-gift-status]');
    if (!select || !btn) return;

    function say(msg, isError) {
      if (!status) return;
      status.textContent = msg;
      status.hidden = false;
      status.classList.toggle('is-error', !!isError);
    }

    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(select.value), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Could not add'); });
          return r.json();
        })
        .then(function () {
          btn.textContent = 'Added \u2713';
          btn.classList.add('is-added');
          say('Your free oil is in the cart. The discount is applied automatically when the diffuser is added too.');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
          setTimeout(function () {
            btn.textContent = original;
            btn.classList.remove('is-added');
            btn.disabled = false;
          }, 2600);
        })
        .catch(function (err) {
          btn.textContent = original;
          btn.disabled = false;
          say(err.message || 'Sorry, that could not be added.', true);
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-cro-gift]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
